import { ErrorHandler, inject, Injectable, Injector } from "@angular/core";
import { NotificationService } from "src/app/common/services/notification.service";

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  /** Directly injecting 'NotificationService' here will cause error 'Circular dependency in DI'. */
  private readonly injector = inject(Injector);
  private notificationService?: NotificationService;
  ERRORS_MSG_TO_SKIP = [
    "Expression has changed after it was checked.",
    "Cannot read properties of null (reading 'classList')",
    "Http failure response for https://graph.microsoft.com/",
    "The play() request was interrupted", // Error from pillarbox, not relevant
    "The pause() request was interrupted", // Error from pillarbox, not relevant
  ];

  handleError(err: unknown): void {
    let msg = (err as { error?: { message?: string } })?.error?.message || (err as { message?: string })?.message;
    msg ||= typeof err === "string" ? err : "";
    for (const errorMessageToSkip of this.ERRORS_MSG_TO_SKIP) {
      if (msg.includes(errorMessageToSkip)) {
        return;
      }
    }
    this.notificationService ??= this.injector.get(NotificationService);
    this.notificationService.showError(err, "Erreur inattendue");
  }
}
